import React, { useState, useEffect } from 'react';

import FURGAPI from '../../services/api.furg';
import { getToken } from '../../services/auth';

import { Loading } from '../Loading';
import Candidato from '.';

const CandidatoLoader = ({ fl_pendencias, vestibular, podeMostrarNotificacaoDeProcessamentoDeferimento = false, podeMostrarNotificacaoDeProcessamentoIndeferimento = false }) => {
    const onDownload = () => {
        const token = getToken(vestibular);
        FURGAPI.download('sischamamentos/Publico/obtemComprovanteSolicitacaoMatricula', {
            token: token,
        }).catch(err => console.log('err', err));
    };

    const [situacaoCalendario, setSituacaoCalendario] = useState({});
    const [candidato, setCandidato] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = getToken(vestibular);
        setLoading(true);
        FURGAPI.call('sischamamentos/Publico/obtemDadosCandidato', { token })
            .then(resposta => {
                setCandidato(resposta);
                setLoading(false);
            })
            .catch(err => setLoading(false));

        FURGAPI.call('sischamamentos/Publico/obtemStatusPeriodoVigente', {
            token,
        })
            .then(resposta => {
                setSituacaoCalendario(resposta);
                setLoading(false);
            })
            .catch(err => setLoading(false));
    }, [vestibular]);

    if (loading) {
        return <Loading />;
    }

    return (
        <Candidato
            onDownload={onDownload}
            situacaoCalendario={situacaoCalendario}
            candidato={candidato}
            fl_pendencias={fl_pendencias}
            vestibular={vestibular}
            podeMostrarNotificacaoDeProcessamentoDeferimento={podeMostrarNotificacaoDeProcessamentoDeferimento}
            podeMostrarNotificacaoDeProcessamentoIndeferimento={podeMostrarNotificacaoDeProcessamentoIndeferimento}
        />
    );
};

export default CandidatoLoader;
